:host {
  @apply block w-full h-full;
}

::slotted(picture[slot=icon]) {
  @apply w-full;
}
